import { CircularProgress } from "@mui/material";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "noval";
import useTranslation from "next-translate/useTranslation";
import { Icon } from "@utils/helper";
import { buildClass } from "@utils/tag";

const SearchController = ({ control, defaultValue }) => {
  const { t } = useTranslation();
  const [loading, search] = useSelector(["homeFundsSearch.loading", "search"]);
  const screen = useSelector("screen");
  const { reset, dispatch } = useDispatch();
  return (
    <Controller
      control={control}
      name="search"
      render={({ field: { value, ...otherRenderProps } }) => {
        return (
          <div className="bg-[rgba(255,255,255,.3)] h-full backdrop-blur-lg sm:bg-[#F3F5F8] py-2 px-4 rounded-[34px] flex items-center justify-start box-border w-full sm:w-[300px] ">
            <button type="submit">
              {loading ? (
                <CircularProgress size={18} />
              ) : (
                <Icon
                  width={19}
                  height={19}
                  id="r5-c12"
                  color={screen === "sm-phone" ? "#fff]" : "#8F8F8F"}
                />
              )}
            </button>
            <input
              {...otherRenderProps}
              type="search"
              className={buildClass(
                "bg-transparent border-0 outline-none",
                "placeholder:text-[#fff] w-full placeholder:sm:text-[#8F8F8F]",
                "text-[13px] leading-none ltr:pl-3 rtl:pr-3"
              )}
              placeholder={t("nav.search_placeholder")}
              onChange={(e) => {
                otherRenderProps.onChange(e);
                if (!e.target.value) {
                  if (search) {
                    dispatch({ resetHomeFunds: true });
                  }
                  reset(["homeFundsSearch", "search"]);
                }
              }}
              onBlur={() => {
                if (value) return;
                if (search) {
                  dispatch({ resetHomeFunds: true });
                }
                reset(["homeFundsSearch", "search"]);
              }}
              defaultValue={defaultValue}
            />
          </div>
        );
      }}
    />
  );
};

export default SearchController;
